import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  makeStyles,
  Spinner,
} from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import classNames from 'classnames';
import { useState } from 'react';

import { StatusLabel } from '@shared/components';

import { useAccess } from '../../api';

import AccessContent from './AccessContent';
import { useUsers } from '@modules/users/api/users.api';
import { TAccessDialogState } from '../../types';

type TProps = {
  state?: TAccessDialogState;
  setState: (state: TAccessDialogState) => void;
};

const useStyles = makeStyles({
  dialog: {
    maxWidth: '640px',
  },
  dialogContent: {
    position: 'relative',
    height: '70vh',
    overflowY: 'auto',
  },
});

const AccessDialog = ({ state, setState }: TProps) => {
  const { error: errorAccess, data: access } = useAccess(state?.id, state?.nodeType);
  const { error: errorUsers, users } = useUsers();
  const data = access && users ? { access, users } : undefined;
  const [isLoading, setIsLoading] = useState(false);

  const classes = useStyles();
  return (
    <Dialog
      open={state?.isOpen || false}
      onOpenChange={(event, data) => {
        if (state) setState({ ...state, isOpen: data.open });
      }}
    >
      <DialogSurface className={classes.dialog}>
        <DialogBody>
          <DialogTitle
            action={
              <DialogTrigger action="close">
                <Button appearance="subtle" aria-label="close" icon={<Dismiss24Regular />} />
              </DialogTrigger>
            }
          >
            Manage access for {state?.name}
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <div
              className={classNames('absolute w-full h-full top-0 left-0 bg-white bg-opacity-50 z-20', {
                hidden: !isLoading,
              })}
            >
              <div className="flex items-center justify-center w-full h-full">
                <Spinner size="large" />
              </div>
            </div>
            <StatusLabel
              data={data}
              loadingMessage="Loading access information..."
              error={errorAccess || errorUsers}
              errorMessage="Loading access information failed!"
              render={(data) =>
                state && <AccessContent {...data} id={state.id} nodeType={state.nodeType} setIsLoading={setIsLoading} />
              }
            />
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default AccessDialog;
